import React, { useState } from 'react'
import { faCalendarCheck, faLayerGroup, faUserTie, faUsers, faUserGear } from '@fortawesome/free-solid-svg-icons'
import MenuLateral from '../MenuLateral/MenuLateral';
import PerfilDashboard from '../PerfilDashboard/PerfilDashboard';
import GestionProfesionales from '../GestionProfesionales/GestionProfesionales';
import DashboardOperativo from '../DashboardOperativo/DashboardOperativo';
import { Clientes } from '../Clientes/Clientes';
import Servicios from '../Servicios/Servicios';

const ZoneGestion2 = ({ tipoDeNegocio }) => {

    const [menuItems, setMenuItems] = useState([
        {
            nombreItem: 'MENU1',
            className: 'menu-item-dashboard-active',
            iconMenu: faCalendarCheck,
            menuLabel: 'Control operativo'
        },
        {
            nombreItem: 'MENU2',
            className: 'menu-item-dashboard',
            iconMenu: faUserGear,
            menuLabel: 'Profesionales'
        },
        /*
        {
            nombreItem: 'MENU3',
            className: 'menu-item-dashboard',
            iconMenu: faLayerGroup,
            menuLabel: 'Servicios'
        },
        */
        {
            nombreItem: 'MENU4',
            className: 'menu-item-dashboard',
            iconMenu: faUsers,
            menuLabel: 'Clientes'
        },
        {
            nombreItem: 'MENU0',
            className: 'menu-item-dashboard',
            iconMenu: faUserTie,
            menuLabel: 'Perfil administrador'
        },
    ]);

    const [stateMenu, setStateMenu] = useState('MENU1');

    const selecionaMenu = (itemSeleccionado) => {
        setStateMenu(itemSeleccionado.nombreItem)
        const nuevoMenuLateral = menuItems.map(itemMenu => {
            if (itemMenu.nombreItem === itemSeleccionado.nombreItem) {
                return { ...itemMenu, className: 'menu-item-dashboard-active' };
            } else {
                return { ...itemMenu, className: 'menu-item-dashboard' };
            }
        });
        setMenuItems(nuevoMenuLateral);
    };

    const componentMenu = () => {
        switch (stateMenu) {
            case 'MENU0':
                return (
                    <PerfilDashboard />
                )
            case 'MENU1':
                return (
                    <DashboardOperativo />
                )
            case 'MENU2':
                return (
                    <GestionProfesionales />
                )
            case 'MENU3':
                return (
                    <Servicios />
                )
            case 'MENU4':
                return (
                    <Clientes />
                )
            default:
                return (
                    <></>
                )
        }
    }

    return (
        <>
            <div className="row m-0">
                <div className="col-12 col-sm-12 col-md-3 col-lg-3 p-0" >
                    <MenuLateral menuItems={menuItems} selecionaMenu={selecionaMenu} />
                </div>
                <div className="col-12 col-sm-12 col-md-9 col-lg-9 p-0" >
                    {
                        componentMenu()
                    }
                </div>
            </div>
        </>
    )
}

export default ZoneGestion2